import { LoginForm, LoginFormTheme } from '@masonic-tools/shared-ui';
import { useAuth } from '@/contexts/AuthContext';

const secretaryTheme: LoginFormTheme = {
  appName: 'Secretary',
  appNameColor: 'text-black',
  welcomeTitle: 'Welcome Back',
  welcomeDescription: 'Access your unit records and communications',
  signUpPath: '/signup',
  resetPasswordPath: '/reset-password',
  defaultReturnPath: '/dashboard',
};

export default function LoginPage() {
  const { login, currentUser } = useAuth();

  const handleLogin = async (email: string, password: string) => {
    await login(email, password);
  };

  return (
    <LoginForm
      theme={secretaryTheme}
      onLogin={handleLogin}
      currentUser={currentUser}
    />
  );
}

